if (!customElements.get('cart-shipping-estimator')) {
  customElements.define(
    'cart-shipping-estimator',
    class CartShippingEstimator extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.form = this.querySelector('form');
        this.input = this.querySelector('input');
        this.button = this.querySelector('button');
        this.message = this.querySelector('[data-shipping-message]');
        this.breakdown = this.querySelector('[data-shipping-breakdown]');
        this.shippingValue = this.querySelector('[data-shipping-value]');
        this.totalValue = this.querySelector('[data-shipping-total]');

        this.form?.addEventListener('submit', (event) => {
          event.preventDefault();
          this.calculate();
        });

        const savedZip = window.localStorage.getItem('collectport-shipping-zip');
        if (savedZip && /^\d{5}$/.test(savedZip)) {
          this.input.value = savedZip;
          this.calculate();
        }
      }

      formatMoney(value) {
        return new Intl.NumberFormat('de-DE', {
          style: 'currency',
          currency: 'EUR',
        }).format(value);
      }

      setMessage(text, isError = false) {
        this.message.textContent = text;
        this.message.dataset.error = isError ? 'true' : 'false';
      }

      async calculate() {
        const zip = this.input.value.trim();
        this.breakdown.hidden = true;

        if (!/^\d{5}$/.test(zip)) {
          this.setMessage('Bitte eine gültige fünfstellige PLZ eingeben.', true);
          this.input.focus();
          return;
        }

        this.button.disabled = true;
        this.setMessage('Versand wird berechnet ...');

        const root = window.Shopify?.routes?.root || '/';
        const params = new URLSearchParams({
          'shipping_address[zip]': zip,
          'shipping_address[country]': 'Germany',
          'shipping_address[country_code]': 'DE',
        });

        try {
          const response = await fetch(`${root}cart/shipping_rates.json?${params.toString()}`, {
            headers: { Accept: 'application/json' },
          });
          const data = await response.json();

          if (!response.ok) {
            throw new Error(data?.error || data?.message || 'Versand konnte nicht berechnet werden.');
          }

          const rates = Array.isArray(data.shipping_rates) ? data.shipping_rates : [];
          if (!rates.length) {
            throw new Error('Für diese PLZ wurde keine Versandart gefunden.');
          }

          const cheapestRate = rates.reduce((cheapest, rate) =>
            Number.parseFloat(rate.price) < Number.parseFloat(cheapest.price) ? rate : cheapest
          );
          const shipping = Number.parseFloat(cheapestRate.price);
          const cartTotal = Number.parseInt(this.dataset.cartTotalCents || '0', 10) / 100;

          this.shippingValue.textContent = this.formatMoney(shipping);
          this.shippingValue.title = cheapestRate.name || '';
          this.totalValue.textContent = this.formatMoney(cartTotal + shipping);
          this.breakdown.hidden = false;
          this.setMessage(cheapestRate.name || 'Günstigste verfügbare Versandart');
          window.localStorage.setItem('collectport-shipping-zip', zip);
        } catch (error) {
          this.setMessage(error.message || 'Versand konnte nicht berechnet werden.', true);
        } finally {
          this.button.disabled = false;
        }
      }
    }
  );
}
